module.exports = __webpack_public_path__ + "static/media/mohammad.28444066.png";